// zh-CN.js
import { headerCN } from "./language/header";
import { footerCN } from "./language/footer";
import { homeCN } from "./language/home";
import { joinUstitleCN, WorkModeCN, WelfareCN, jobCN } from "./language/joinUs";
import { aboutUsCN } from "./language/aboutUs";
import { technologyCN } from "./language/technology";
import { productCenterGaiAViewCN } from "./language/productCenterGaiAView";
import { productCenterPDRHeaViewCN } from "./language/productCenterPDRHeaView";
import { productCenterHiLViewCN } from "./language/productCenterHiLView";
import { productCenterDriveViewCN } from "./language/productCenterDriveView";
import { productCenterSiLViewCN } from "./language/productCenterSiLView";
import { productCentermeidushaViewCN } from "./language/productCentermeidushaView";
import { productCenterHerculesViewCN } from "./language/productCenterHerculesView";
import { productCenterUranusCN } from "./language/productCenterUranus";
import { productCenterRobotCN } from "./language/productCenterRobot";
import { modelSharePlatformCN } from "./language/ecosphere/modelSharePlatform";
import { ecologicalCooperationSharePlatformCN } from "./language/ecosphere/ecologicalCooperationSharePlatform";
import { fullScaleAutonomousDrivingCN } from "./language/ecosphere/fullScaleAutonomousDriving";

export default {
  header: headerCN,
  footer: footerCN,

  home: homeCN,
  joinUstitle: joinUstitleCN,
  WorkMode: WorkModeCN,
  Welfare: WelfareCN,
  job: jobCN,
  aboutUs: aboutUsCN,
  technology: technologyCN,
  productCenterGaiAView: productCenterGaiAViewCN,
  productCenterPDRHeaView: productCenterPDRHeaViewCN,
  productCenterHiLView: productCenterHiLViewCN,
  productCenterDriveView: productCenterDriveViewCN,
  productCenterSiLView: productCenterSiLViewCN,
  productCentermeidushaView: productCentermeidushaViewCN,
  productCenterHerculesView: productCenterHerculesViewCN,
  productCenterUranus: productCenterUranusCN,
  productCenterRobot: productCenterRobotCN,
  ecosphereModelSharePlatform: modelSharePlatformCN,
  ecosphereCooperationSharePlatform: ecologicalCooperationSharePlatformCN,
  ecosphereFullScaleAutonomousDriving: fullScaleAutonomousDrivingCN,
};
